import { useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, useEffect, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import { ARROW_UP_KEY, ARROW_DOWN_KEY, ENTER_KEY } from './constants.js';
import Field from './Field.js';

const TimePeriodFormatField = ({
  value,
  onChange,
  name,
  label,
  options,
  onEnterPress,
  styles = {}
}) => {
  const theme = useTheme();
  const [innerValue, setInnerValue] = useState(value);
  const handleUpClick = () => {
    setInnerValue(prevValue => {
      const currentValueIndex = options.findIndex(option => prevValue.value === option.value);
      const newIndex = currentValueIndex === options.length - 1 ? 0 : currentValueIndex + 1;
      return options[newIndex];
    });
  };
  const handleDownClick = () => {
    setInnerValue(prevValue => {
      const currentValueIndex = options.findIndex(option => prevValue.value === option.value);
      const newIndex = currentValueIndex === 0 ? options.length - 1 : currentValueIndex - 1;
      return options[newIndex];
    });
  };
  const handleInputKeyDown = event => {
    if (event.key === ARROW_UP_KEY) {
      handleUpClick();
    }
    if (event.key === ARROW_DOWN_KEY) {
      handleDownClick();
    }
    if (event.key === ENTER_KEY) {
      onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress();
    }
  };
  useEffect(() => {
    if (innerValue !== value) {
      onChange(innerValue);
    }
  }, [innerValue]);
  return /*#__PURE__*/createElement(Field, {
    onUpClick: handleUpClick,
    onDownClick: handleDownClick
  }, /*#__PURE__*/createElement(TextInput, {
    label: label,
    value: innerValue.label,
    name: name,
    readOnly: true,
    onKeyDown: handleInputKeyDown,
    styles: {
      root: _objectSpread2({
        width: '64px',
        bg: theme.palette.common.white
      }, styles.root),
      input: _objectSpread2({
        border: `1px solid ${theme.palette.grey[60]} !important`,
        textAlign: 'center'
      }, styles.input),
      label: _objectSpread2({}, styles.label)
    },
    maxLength: 2
  }));
};

export default TimePeriodFormatField;
